import './App.scss';
import Main from './components/Main.js';
import { initHeaderForm } from './lib/Header.js';
import { initSidebar } from './lib/Sidebar.js';

function App() {
	initSidebar();
	initHeaderForm();

	return (
		<div className="App">
			<Main/>
		</div>
	);
}

export default App;
